export enum EEecsGoAccountVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum EProductionTechnology {
  SOLAR = 'T01',
  WIND = 'T02',
  HYDRO = 'T03',
  MARINE = 'T04',
  THERMAL = 'T05',
  NUCLEAR = 'T06',
  OTHER = 'T07',
}

export enum ECertificateType {
  SPOT = 'spot',
  FORWARD = 'forward',
}

export enum ECertificateDocumentType {
  ISO = 'iso',
  TUV_SUD = 'tuv_sud',
  TUV_RHEINLAND = 'tuv_rheinland',
  TUV_NORD = 'tuv_nord',
  OTHER = 'other',
}

export enum EEnergySource {
  UNSPECIFIED = 'F00',
  RENEWABLE = 'F01',
  FOSSIL = 'F02',
  NUCLEAR = 'F03',
  GAS_SYNTHESIS = 'F04',
  WASTE_HEAT_COLD = 'F05',
}

export enum EAibGrid {
  YES = 1,
  NO = 0,
}

export enum EEecsRegistry {
  NECS = 'necs',
  HKNR = 'hknr',
  GREX_DK = 'grex_dk',
}

export enum ETypeOfSupport {
  NO_SUPPORT = 'no_support',
  PRODUCTION = 'production',
}

export interface IEnergyTypes {
  type_of_installation_code: string;
  type_of_installation_path: string[];
  energy_source_code: string;
  energy_source_path: string[];
}

export interface ICounterPartyWhiteListing {
  we_added: boolean;
  they_added: boolean;
  we_trust: boolean;
  they_trust: boolean;
}

export interface ICounterParty {
  id?: number | null;
  name?: string | null;
  white_listing?: ICounterPartyWhiteListing;
  bundle_id?: number | null;
  member_source_code?: string | null;
}

export interface IEecsAccount {
  id: number;
  status: boolean;
  email: string;
  organization_name: string;
  account_holder_code: string;
  is_complete_flow: boolean;
  registry: EEecsRegistry;
}

export interface IEecsGoAccount {
  id: number;
  buyer: boolean;
  seller: boolean;
  account_number: string;
  name: string;
  default_account: boolean;
  visibility: EEecsGoAccountVisibility;
  has_transactions: boolean;
}
